<template>
  <div class="commonField" :class="{ oneline }">
    <div class="label">
      <div class="circle"></div>
      <span v-if="showLabel">{{ label }}</span>
    </div>
    <div class="box" :class="{ nodata, 'show-errorMsg': errorMsg }">
      <van-field
        :readonly="isDrop || readonly"
        :placeholder="placeholder"
        :input-align="oneline ? 'right' : 'left'"
        v-model.trim="content"
        :clearable="true"
        @click="$emit('click')"
        @focus="$emit('focus')"
        @paste="$emit('paste')"
        @blur="$emit('blur')"
        :type="type"
        :style="{ marginRight: email ? '8px' : '' }"
      >
        <template #right-icon v-if="isDrop">
          <van-icon name="arrow-down" color="#12033a" />
        </template>
        <template #button>
          <slot name="button"></slot>
        </template>
      </van-field>
      <span v-if="email">Google</span>
    </div>
    <div class="error" v-show="errorMsg">{{ errorMsg }}</div>
  </div>
</template>

<script>
export default {
  name: 'CommonField',
  props: {
    value: { type: [String, Number], default: '' },
    placeholder: { type: String, default: '' },
    type: { type: String, default: '' },
    label: { type: String, default: '' },
    isDrop: { type: Boolean, default: false },
    oneline: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    errorMsg: { type: String, default: '' },
    email: { type: Boolean, default: false },
    nodata: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true }
  },

  computed: {
    content: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.label {
  margin: 6px 0 8px;
  font-size: 14px;
  text-align: left;
  color: #32343d;
}
.oneline {
  display: flex;
  padding: 0.05rem 0;
  align-items: center;
}
.oneline .label {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin: 0;
}
.oneline .circle {
  margin: 0.04rem 0.1rem 0 0;
  width: 0.12rem;
  height: 0.12rem;
  vertical-align: middle;
  border-radius: 50%;
  background: #ffd0a8;
}
.error {
  margin: 0.2rem 0 0 0.2rem;
  text-align: left;
  font-size: 12px;
  color: #ff0101;
}
.van-field {
  background: #f6f6f6;
  border-radius: 12px;
  padding: 15px;
}
.box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    padding: 18px 30px;
    font-size: 14px;
    color: #fff;
    line-height: 16px;
    background: #01947f;
    border-radius: 8px;
  }
}
.nodata {
  border: 1px solid red;
  border-radius: 8px;
  box-sizing: border-box;
  ::v-deep input::placeholder {
    color: red !important;
  }
}
.show-errorMsg {
  background: #f6f6f6;
  border: 1px solid red;
  box-sizing: border-box;
  border-radius: 8px;
  /deep/ .van-field__control {
    color: red;
  }
}
</style>
